import { Card } from '../../../components/ui/card.tsx';
import { CollapsibleContainer } from '../../../components/ui/collapsible-container.tsx';
import { CollapsibleText } from '../../../components/ui/collapsible-text.tsx';
import { useLocale } from '../../../lib/hooks/use-locale.ts';
import type { RouterOutput } from '../../../server/types/infer-trpc-types.ts';
import { RichTextViewer } from '../../rich-text/components/rich-text-viewer.tsx';

type Props = {
    data: RouterOutput['platoUser']['getDetailProduct']['getProductDetail'];
};

export const InventoryDetailsDescription = ({ data: data }: Props) => {
    const { t } = useLocale();

    // Use the backend-provided combined and sanitized description
    if (!data.description) {
        return null;
    }

    return (
        <CollapsibleContainer defaultOpen title={t('description', { ns: 'product-details' })}>
            <Card>
                <CollapsibleText canOpen>
                    <RichTextViewer content={data.description} />
                </CollapsibleText>
            </Card>
        </CollapsibleContainer>
    );
};
